module.exports = __webpack_public_path__ + "static/media/1.3405dc39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/bobruisk/1.jpg
// module id = 210
// module chunks = 0